import React, { useState } from "react";
import { MarketplaceDetailContent } from "../../blocks/marketplace-detail-content";
import { Header } from "../../components/Header";
import { useNavigate, useParams } from "react-router";
import "./styles.less";
import { useTranslation } from "react-i18next";
import Axios from "axios";
import { useEffect } from "react";
import { Footer } from "../../components/FooterV2";
import { Helmet } from "react-helmet";
import { marketplaceMapTitle } from "../../utils/marketplaceMap";

export const MarketplaceDetailPage = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { macketplaceDetailData } = props;
  const [detail, setDetail] = useState(macketplaceDetailData);
  const nav = useNavigate();

  useEffect(() => {
    Axios.get(`/api/marketplace-detail?identifier=${id}`).then((res) => {
      if (res?.data?.code === 200) {
        setDetail(res?.data?.data || {});
      } else {
        nav("/error/404");
      }
    });
  }, [id, nav]);

  return (
    <div className="marketplace-detail-page">
      <Helmet>
        <title>{marketplaceMapTitle[id]}</title>
      </Helmet>
      <Header />
      <MarketplaceDetailContent data={detail} id={id} />
      <Footer />
    </div>
  );
};
